import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import Content from "../../components/Content"

const InfoBarWidgetList = ({container}) => {
    const {children, size} = container
    return (
        <Box
            sx={{display: "grid", gridTemplateColumns: `repeat(${size}, 1fr)`}}
            pb={1}>
            {children?.map((widget) => (
                <Box
                    key={widget.id}
                    bgcolor={widget.background && "#ddddff"}
                    sx={{gridColumn: `span ${widget.size}`}}>
                    <Content child={widget} />
                </Box>
            ))}
        </Box>
    )
}

InfoBarWidgetList.propTypes = {
    container: PropTypes.object,
}

export default InfoBarWidgetList
